$(function () {
  let case_popup_left_container_container;
  function changeProductQty(that, flag = false) {
    let val = !flag ? +that.data("qty") : 0,
      cur_val =
        +that
          .parents(".case-item-container")
          .find(".js-case-qty__num")
          .prop("value") + val;
    let max = +that
      .parents(".case-item-container")
      .find(".js-case-qty__num")
      .prop("max");
    if (cur_val >= 0 && cur_val <= max) {
      that
        .parents(".case-item-container")
        .find(".js-case-qty__num")
        .prop("value", cur_val);
      that.parents(".case-container-item").find(".tips-content").length > 0 &&
        that.parents(".case-container-item").find(".tips-content").hide();
    } else if (cur_val > max) {
      that
        .parents(".case-item-container")
        .find(".js-case-qty__num")
        .prop("value", max);
      that.parents(".case-container-item").find(".tips-content").length > 0 &&
        that.parents(".case-container-item").find(".tips-content").show();
    }
  }
  function calcProductPrice(total_price) {
    return window.theme.Currency.formatMoney(
      total_price,
      window.theme.strings.moneyFormat
    );
  }
  function update_out_inside_qty(direction = "outside") {
    let str =
      direction == "inside" ? ".case-popup-content" : ".header-case-content";
    let str_1 =
      direction == "inside" ? ".header-case-content" : ".case-popup-content";
    $(`${str} .case-item-container`).each(function () {
      let id = +$(this).find(".js-case-qty__num").data("id"),
        val = $(this).find(".js-case-qty__num").prop("value"),
        index = $(this).data("index");
      $(`${str_1} .case-item`).find(`input[data-id=${id}]`).prop("value", val);
      updateProductPrice(
        $(`${str_1} .case-container-item[data-index="${index}"]`)
      );
    });
  }

  function updateProductPrice(that) {
    var $input = that.find(".js-case-qty__num");
    var qty = +$input.prop("value") || 1;
    var price = +$input.attr("data-price") || 0;
    var compare_at = +$input.attr("data-compare_at_price") || 0;
    var total = qty * price;
    var compare_total = qty * compare_at;
    var $saveTag = that.find(".item-price .save-tag");

    that.find(".item-price .on_sale-price").html(calcProductPrice(total));
    compare_total > 0 &&
      that
        .find(".item-price .compare_at-price")
        .html(calcProductPrice(compare_total));

    if (compare_total > total) {
      // 节省金额 (data-price 存的是分, 需除以 100)
      var saveAmount = Math.round((compare_total - total) / 100);
      var saveFormatted =
        String(saveAmount).replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " kr";
      $saveTag.text("SPARA " + saveFormatted).show();
    } else {
      $saveTag.hide();
    }
  }
  function update_totalProductPrice() {
    let total_price = +$(
      "[data-product-template-container] .custom_add_to_cart"
    ).data("on_sale_price");
    let total_compare_price = !$(
      "[data-product-template-container] .custom_add_to_cart"
    ).data("compare_at_price")
      ? total_price
      : +$("[data-product-template-container] .custom_add_to_cart").data(
          "compare_at_price"
        );
    $(".header-case-content .case-item .js-case-qty__num").each(function () {
      let temp = +$(this).data("price") * $(this).prop("value");
      total_price += temp;
      total_compare_price += !$(this).data("compare_at_price")
        ? temp
        : $(this).data("compare_at_price") * $(this).prop("value");
    });
    let val = calcProductPrice(total_price),
      val_compare = calcProductPrice(total_compare_price);
    $("[data-product-template-container] .product_on-sale-price").text(val);

    if (total_compare_price == total_price) {
      $("[data-product-template-container] .product_compare-at-price").remove();
    } else {
      if (
        $("[data-product-template-container] .price-container").find(
          ".product_compare-at-price"
        ).length > 0
      ) {
        $("[data-product-template-container] .product_compare-at-price").text(
          val_compare
        );
      } else {
        $("[data-product-template-container] .product_on-sale-price").after(
          `<span class='product-single__price--compare-at product_compare-at-price'>${val_compare}</span>`
        );
      }
    }
  }

  async function addOneToCart(variants) {
    for (let i = 0; i < variants.length; i++) {
      let variant = variants[i];
      let response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variant.id, quantity: variant.quantity }),
      });
      if (!response.ok) {
        throw new Error("添加产品失败: " + variant.id);
      }
      const data = await response.json();
      await new Promise((resolve) => setTimeout(resolve, 200));
      if (i == variants.length - 1) {
        $("[data-product-template-container] .custom_add_to_cart").removeClass(
          "loading"
        );
        $(".js-drawer-open-button-right").trigger("click");
      }
    }
  }
  function fadeInPopUp() {
    $("html").addClass("overflow-hidden");
    $(".product-showcase-info-container .case-popup-content").removeClass(
      "caseopacity0"
    );
    $(".product-showcase-info-container").find(".tips-content").hide();
    update_out_inside_qty();
  }
  function fadeOutPopUp(flag = false) {
    $("html").removeClass("overflow-hidden");
    $(".product-showcase-info-container .case-popup-content").addClass(
      "caseopacity0"
    );
    if (flag) {
      update_out_inside_qty("inside");
    }
  }
  function setOriginPopUpContent(index) {
    $(".case-popup-right")
      .find(`.right-item[data-index="${index}"]`)
      .addClass("active")
      .siblings()
      .removeClass("active");
    case_popup_left_container_container.slideTo(index);
  }

  $(".case-popup-content").click(function () {
    fadeOutPopUp();
  });
  $(".case-popup-content-container").click(function (event) {
    event.stopPropagation();
  });
  $(".product-showcase-info-container .header-case-btn").on(
    "click",
    function () {
      // 点击弹出窗口
      fadeInPopUp();
    }
  );
  $(".product-showcase-info-container .case-hide-btn").on("click", function () {
    // 点击隐藏窗口
    fadeOutPopUp();
  });
  // 点击对应的item进入弹窗
  // $(".product-showcase-info-container .header-case-content .case-item").on(
  //   "click",
  //   function () {
  //     let index = $(this).parents(".swiper-slide").data("index");
  //     setOriginPopUpContent(index);
  //     fadeInPopUp();
  //     let val=+$(this).find(".js-case-qty__num").prop("value")
  //     if(val>0){
  //       $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).addClass("active")
  //     }else{
  //       $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).removeClass("active")
  //     }

  //   }
  // );
  // 点击产品加购根据每个产品的id来循环加购
  $("[data-product-template-container] .custom_add_to_cart").click(function () {
    let product_qty = +$(this)
      .parents("[data-product-form]")
      .find(".product-single__quantity .js-qty__num")
      .prop("value");
    product_qty = product_qty > 1 ? product_qty : 1;
    $(this).addClass("loading");
    // 循环每个不同的产品
    let arr_item = [
      {
        id: $(this).data("id"),
        quantity: product_qty,
      },
    ];
    $(".header-case-content .js-case-qty__num").each(function () {
      let qty = +$(this).prop("value");
      if (qty > 0) {
        let obj = {
          id: $(this).data("id"),
          product_id: $(this).data("product-id"),
          quantity: qty,
        };
        arr_item.push(obj);
      }
    });

    arr_item.length > 0 && addOneToCart(arr_item);
  });
  // 点击该处按钮实现+1   点击该处按钮实现-1
  $(".product-showcase-info-container .js-case__adjust").on(
    "click",
    function (event) {
      let that = $(this),
        that_parent = $(this).parents(".case-item-container");
      changeProductQty(that);
      updateProductPrice(that_parent);
      if (!!$(this).data("layout")) {
        update_totalProductPrice();
      }
      return false;
    }
  );
  $(
    ".product-showcase-info-container .case-popup-content .js-case-qty__num"
  ).on("change", function () {
    let that = $(this),
      that_parent = $(this).parents(".case-item-container");
    updateProductPrice(that_parent);
    changeProductQty(that, true);
  });
  // 弹窗切换item状态
  $(".case-popup-right .right-item").on("click", function () {
    let index = $(this).data("index");
    setOriginPopUpContent(index);
  });
  // m端点击弹窗关闭
  $(".case-popup-left .m-close ").on("click", function () {
    fadeOutPopUp();
  });
  //点击确定加购
  $(".case-popup-left .confirm-btn ").on("click", function () {
    let index = $(this).parents(".left-item").data("index");
    let val = +$(this)
      .parents(".case-item-container")
      .find(".js-case-qty__num")
      .prop("value");
    update_out_inside_qty("inside");
    calcProductPrice();
    update_totalProductPrice();
    if (val > 0) {
      $(
        `.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`
      ).addClass("active");
    } else {
      $(
        `.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`
      ).removeClass("active");
    }
  });

  //循环里面的swiper
  case_popup_left_container_container = new Swiper(
    ".case-popup-left-container>.swiper",
    {
      allowTouchMove: false,
      autoHeight: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
    }
  );

  $(".case-popup-left .left-item").each(function (index) {
    new Swiper(`.left-swiper-${index} .swiper`, {
      pagination: {
        el: `.left-swiper-${index} .swiper-pagination`,
        clickable: true,
      },
    });
  });

  // 模拟buy now按钮加购到checkout
  $(".custom_buy_now--btn").on("click", function () {
    // 1. 获取主商品信息
    let items = [];
    const variant_id = +$(".product-single__variants option:selected").prop(
      "value"
    );
    const $quantityInput = $(this)
      .parents("[data-product-form]")
      .find(".product-single__quantity .js-qty__num");
    const qty = $quantityInput.length ? +$quantityInput.prop("value") || 1 : 1;

    if (variant_id) {
      items.push({ id: variant_id, quantity: qty });
    }

    // 2. 获取套餐商品（或其他附加商品）
    $(".header-case-content .js-case-qty__num").each(function () {
      const case_qty = +$(this).prop("value");
      if (case_qty > 0) {
        items.push({
          id: $(this).data("id"),
          quantity: case_qty,
        });
      }
    });

    // 3. 构建 Shopify Cart URL 格式
    const cartRoute = window.routes?.cart_url ?? "/cart";
    let paramString = "";

    if (items.length === 1) {
      // 单个商品：/cart/id:qty
      paramString = `${items[0].id}:${items[0].quantity}`;
    } else if (items.length > 1) {
      // 多个商品：/cart/id1:qty1,id2:qty2,...
      paramString = items
        .map((item) => `${item.id}:${item.quantity}`)
        .join(",");
    }

    // 4. 跳转到购物车页（自动加购）
    if (paramString) {
      window.location.href = `${cartRoute}/${paramString}`;
    } else {
      console.error("No valid items to add to cart.");
    }
  });
});
